
import Vue from "vue";
import App from "./App";
import router from "./router/index";
// import router from './router'

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueMeta from 'vue-meta';

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'



// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(PaperDashboard);

Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)


Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

/* eslint-disable no-new */
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
